/* input */
/*--------------------------------------------------------------------------------*/
export const setAutoSize = (elm: HTMLTextAreaElement) => {
    elm.onkeyup = () => fitSize(elm);
};
export const fitSize = (elm: HTMLTextAreaElement, delay = 0) => {
    setTimeout(() => {
        elm.style.height = 'auto';
        elm.style.height = `${elm.scrollHeight + 2}px`;
    }, delay);
};
/*--------------------------------------------------------------------------------*/
